import React from "react";
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import { FilterList, Search } from "@material-ui/icons";
import Select from '../filters/Select';
import Date from '../filters/Date';
import Slider from '../filters/Slider';
import Diapason from '../filters/Diapason';

export const ColumnFilter = (ctx) => {
  const { filterValue, setFilter, filterType } = ctx.column;
  function changeFilter(value) {
    setFilter(value);
  }

  const baseValue = [...ctx.data];
  return (
    <>
      {(() => {
        switch(filterType) {
          case 'select': 
            return <Select 
              filter={changeFilter}
              name={ctx.column.Header}
              values={baseValue.map(i => i[ctx.column.id])}
            />
          case 'date':
            return <Date 
              filter={changeFilter}
              values={[...new Set(baseValue.map(i => i[ctx.column.id]))]}
            />;
          case 'slider':
            return <Slider 
              filter={changeFilter}
              values={[...new Set(baseValue.map(i => i[ctx.column.id]))].sort((a, b) => b - a)}
            />;
          case 'diapason':
            return <Diapason 
              filter={changeFilter}
              values={[...new Set(baseValue.map(i => i[ctx.column.id]))].sort((a, b) => Number(b) - Number(a))}
            />;
          default: 
            return <Input
              value={filterValue || ""}
              placeholder={ctx.column.Header}
              onChange={(e) => setFilter(e.target.value)}
              startAdornment={
                <InputAdornment position="start">
                  <FilterList />
                </InputAdornment>
              }
            />
        }
      })()}
    </>
  );
};
